"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoreDataSecurityAppStatusSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const data_security_1 = require("../../../api/data-security/index.js");
exports.getCoreDataSecurityAppStatusSlice = (0, xuder_1.createGetAsyncSlice)({
    name: 'CoreDataSecurityAppStatus',
    receive: true,
    request: true,
    requestHandler: data_security_1.getDataSecurityAppStatus,
    retainDataOnRequest: true
});
//# sourceMappingURL=get.js.map